import { Icon, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { Plus } from 'lucide-react'

interface Props extends Omit<IconButtonProps, 'aria-label'> {}

const Component = ({ isLoading, onClick, ...props }: Props) => {
  return (
    <Tooltip label="Adicionar">
      <IconButton
        colorScheme="primary"
        aria-label="Adicionar"
        isLoading={isLoading}
        onClick={onClick}
        icon={<Icon as={Plus} />}
        {...props}
      />
    </Tooltip>
  )
}

export default Component
